export default __webpack_public_path__ + "static/media/twitter.e3897e9c.svg";